import CircularLoader from "components/CircularLoader";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "~/common/hooks/useAuthContext";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const auth = useAuthContext();

  if (auth.isLoading) {
    return <CircularLoader />;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
